/* components/SourceInput.svelte generated by Svelte v3.44.1 */
import {
	SvelteComponent,
	attr,
	component_subscribe,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	set_input_value
} from "svelte/internal";

import { sourceQuery } from '../stores.js';

function create_fragment(ctx) {
	let textarea;
	let mounted;
	let dispose;

	return {
		c() {
			textarea = element("textarea");
			attr(textarea, "placeholder", "Put sources here");
			attr(textarea, "class", "svelte-13bpgqq");
		},
		m(target, anchor) {
			insert(target, textarea, anchor);
			set_input_value(textarea, /*$sourceQuery*/ ctx[0]);

			if (!mounted) {
				dispose = listen(textarea, "input", /*textarea_input_handler*/ ctx[1]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*$sourceQuery*/ 1) {
				set_input_value(textarea, /*$sourceQuery*/ ctx[0]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(textarea);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $sourceQuery;
	component_subscribe($$self, sourceQuery, $$value => $$invalidate(0, $sourceQuery = $$value));

	function textarea_input_handler() {
		$sourceQuery = this.value;
		sourceQuery.set($sourceQuery);
	}

	return [$sourceQuery, textarea_input_handler];
}

class SourceInput extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default SourceInput;